import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus, Clock, Eye } from "@phosphor-icons/react";
import { Card, money } from "@/components/finance/fin";
import { BudgetLineRow } from "./BudgetLineRow";
import { INCOME_CATS, EXPENSE_CATS, manualLine } from "./budgetModel";

export function BudgetSection({ section, lines, setLines, rates, total, subtitle }) {
  const income = section === "income";
  const cats = income ? INCOME_CATS : EXPENSE_CATS;
  const [cat, setCat] = useState(cats[0][0]);
  const mine = lines.filter((l) => l.section === section);
  const shown = mine.filter((l) => !l.excluded);
  const hidden = mine.filter((l) => l.excluded);
  const update = (id, next) => setLines(lines.map((l) => (l.id === id ? next : l)));
  const remove = (l) => setLines(l.source === "manual" ? lines.filter((x) => x.id !== l.id) : lines.map((x) => (x.id === l.id ? { ...x, excluded: true } : x)));
  const add = (c, hours) => setLines([...lines, manualLine(section, c, hours ? rates || {} : null)]);
  return (
    <Card title={income ? "Income" : "Expenses"} subtitle={subtitle} testId={`budget-${section}`}
      right={<p className="text-lg font-black tabular-nums" data-testid={`budget-${section}-section-total`}>{money(total)}</p>}>
      <div className="space-y-2">
        {shown.length === 0 && <p className="text-sm text-muted-foreground py-2" data-testid={`budget-${section}-empty`}>{income ? "No earnings found in your tracker for this month — add income below." : "No expenses yet — add one below or set up recurring expenses."}</p>}
        {shown.map((l) => <BudgetLineRow key={l.id} line={l} rates={rates} onChange={(n) => update(l.id, n)} onRemove={() => remove(l)} />)}
      </div>
      <div className="flex flex-wrap items-center gap-2 mt-4 pt-4 border-t border-border/60">
        <select value={cat} onChange={(e) => setCat(e.target.value)} data-testid={`budget-${section}-add-category`} className="h-9 rounded-md border border-input bg-secondary/40 px-2 text-sm">
          {cats.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <Button size="sm" variant="outline" data-testid={`budget-${section}-add-btn`} onClick={() => add(cat, false)}><Plus className="h-4 w-4 mr-1" /> Add</Button>
        {income && <>
          <Button size="sm" variant="ghost" data-testid="budget-add-ot-hours" onClick={() => add("overtime", true)}><Clock className="h-4 w-4 mr-1" /> Overtime hours</Button>
          <Button size="sm" variant="ghost" data-testid="budget-add-pd-hours" onClick={() => add("paid_duty", true)}><Clock className="h-4 w-4 mr-1" /> Paid duty hours</Button>
        </>}
      </div>
      {hidden.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2 text-xs text-muted-foreground" data-testid={`budget-${section}-hidden`}>
          <span>Hidden imports:</span>
          {hidden.map((l) => <button key={l.id} data-testid={`budget-restore-${l.id}`} className="inline-flex items-center gap-1 rounded bg-secondary px-2 py-0.5 hover:text-primary" onClick={() => update(l.id, { ...l, excluded: false })}><Eye className="h-3 w-3" /> {l.label}</button>)}
        </div>
      )}
    </Card>
  );
}
